<template>
    <h1>Whatever my next mini-project is.</h1>
    <p>Even I don't know what's going here yet.</p>
</template>